import { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import api, { formatApiError } from "../api";

const SuperAuthContext = createContext(null);

export function SuperAuthProvider({ children }) {
  const [sa, setSa] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchMe = useCallback(async () => {
    const token = localStorage.getItem("flr_super_token");
    if (!token) {
      setSa(null);
      setLoading(false);
      return;
    }
    try {
      const { data } = await api.get("/super/me");
      setSa(data);
    } catch (e) {
      localStorage.removeItem("flr_super_token");
      setSa(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { fetchMe(); }, [fetchMe]);

  const login = useCallback(async (email, password) => {
    try {
      const { data } = await api.post("/super/auth/login", { email, password });
      localStorage.setItem("flr_super_token", data.token);
      setSa(data.super_admin);
      return { ok: true };
    } catch (e) {
      return { ok: false, error: formatApiError(e) };
    }
  }, []);

  const logout = useCallback(() => {
    localStorage.removeItem("flr_super_token");
    setSa(null);
  }, []);

  const value = useMemo(() => ({ sa, loading, login, logout, refresh: fetchMe }), [sa, loading, login, logout, fetchMe]);
  return <SuperAuthContext.Provider value={value}>{children}</SuperAuthContext.Provider>;
}

export function useSuperAuth() {
  return useContext(SuperAuthContext);
}
